define("calendar/services/events", ["exports", "@ember/object/computed", "@ember/service", "@ember/utils", "ember-concurrency-decorators", "ember-concurrency-ts", "moment", "moment-timezone", "tracked-built-ins", "later/helpers/profile-color-outline-class", "later/models/calendar-event", "later/utils/constants", "later/utils/find-best-fit-open-timeslot", "shared/utils/time"], function (_exports, _computed, _service, _utils, _emberConcurrencyDecorators, _emberConcurrencyTs, _moment, _momentTimezone, _trackedBuiltIns, _profileColorOutlineClass, _calendarEvent, _constants, _findBestFitOpenTimeslot, _time) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _addBttpPromoEvent, _createBttpPromoTimeSlotEvent, _eventsFetched, _fetchFromStore, _fetchOrIgnoreNotes, _filterNotes, _filterPosts, _formatPostsAsEvents, _formatNotesAsEvents, _formatTimeSlotsAsEvents, _getInitialDate, _getParams, _isWithinDates, _queryDate;

  0; //eaimeta@70e063a35619d71f0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"ember-concurrency-decorators",0,"ember-concurrency-ts",0,"moment",0,"moment-timezone",0,"tracked-built-ins",0,"later/helpers/profile-color-outline-class",0,"later/models/calendar-event",0,"later/utils/constants",0,"later/utils/find-best-fit-open-timeslot",0,"shared/utils/time"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const {
    NOTE,
    BTTP,
    BTTP_PROMO,
    TIME_SLOT,
    POST
  } = _constants.CALENDAR_EVENT_TYPES;
  const {
    DEFAULT,
    STORIES
  } = _constants.CALENDAR_TYPES;
  const {
    WEEK,
    MONTH
  } = _constants.CALENDAR_VIEW_TYPES;
  let EventsService = (_dec = (0, _service.inject)('config'), _dec2 = (0, _computed.readOnly)('auth.currentAccount'), _dec3 = (0, _computed.readOnly)('auth.currentGroup.id'), _dec4 = (0, _computed.readOnly)('selectedSocialProfiles.hasMultipleSelected'), _dec5 = (0, _computed.readOnly)('selectedSocialProfiles.firstProfile'), (_class = (_addBttpPromoEvent = /*#__PURE__*/new WeakSet(), _createBttpPromoTimeSlotEvent = /*#__PURE__*/new WeakSet(), _eventsFetched = /*#__PURE__*/new WeakSet(), _fetchFromStore = /*#__PURE__*/new WeakSet(), _fetchOrIgnoreNotes = /*#__PURE__*/new WeakSet(), _filterNotes = /*#__PURE__*/new WeakSet(), _filterPosts = /*#__PURE__*/new WeakSet(), _formatPostsAsEvents = /*#__PURE__*/new WeakSet(), _formatNotesAsEvents = /*#__PURE__*/new WeakSet(), _formatTimeSlotsAsEvents = /*#__PURE__*/new WeakSet(), _getInitialDate = /*#__PURE__*/new WeakSet(), _getParams = /*#__PURE__*/new WeakSet(), _isWithinDates = /*#__PURE__*/new WeakSet(), _queryDate = /*#__PURE__*/new WeakSet(), class EventsService extends _service.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _queryDate);

      _classPrivateMethodInitSpec(this, _isWithinDates);

      _classPrivateMethodInitSpec(this, _getParams);

      _classPrivateMethodInitSpec(this, _getInitialDate);

      _classPrivateMethodInitSpec(this, _formatTimeSlotsAsEvents);

      _classPrivateMethodInitSpec(this, _formatNotesAsEvents);

      _classPrivateMethodInitSpec(this, _formatPostsAsEvents);

      _classPrivateMethodInitSpec(this, _filterPosts);

      _classPrivateMethodInitSpec(this, _filterNotes);

      _classPrivateMethodInitSpec(this, _fetchOrIgnoreNotes);

      _classPrivateMethodInitSpec(this, _fetchFromStore);

      _classPrivateMethodInitSpec(this, _eventsFetched);

      _classPrivateMethodInitSpec(this, _createBttpPromoTimeSlotEvent);

      _classPrivateMethodInitSpec(this, _addBttpPromoEvent);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "bttp", _descriptor2, this);

      _initializerDefineProperty(this, "calendarConfig", _descriptor3, this);

      _initializerDefineProperty(this, "errors", _descriptor4, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor5, this);

      _initializerDefineProperty(this, "store", _descriptor6, this);

      _initializerDefineProperty(this, "userConfig", _descriptor7, this);

      _defineProperty(this, "calendarType", DEFAULT);

      _defineProperty(this, "defaultTimedEventDuration", '01:00:00');

      _defineProperty(this, "fetchedDateRanges", new _trackedBuiltIns.TrackedArray([]));

      _defineProperty(this, "fullCalendar", null);

      _initializerDefineProperty(this, "account", _descriptor8, this);

      _initializerDefineProperty(this, "currentGroupId", _descriptor9, this);

      _initializerDefineProperty(this, "multipleProfilesSelected", _descriptor10, this);

      _initializerDefineProperty(this, "singleSocialProfile", _descriptor11, this);
    }

    get defaultFetchInfo() {
      var _this$calendarConfig$, _this$calendarConfig$2, _this$calendarConfig$3, _this$calendarConfig$4;

      return {
        start: (_this$calendarConfig$ = (_this$calendarConfig$2 = this.calendarConfig.fullCalendar) === null || _this$calendarConfig$2 === void 0 ? void 0 : _this$calendarConfig$2.view.activeStart) !== null && _this$calendarConfig$ !== void 0 ? _this$calendarConfig$ : new Date(),
        end: (_this$calendarConfig$3 = (_this$calendarConfig$4 = this.calendarConfig.fullCalendar) === null || _this$calendarConfig$4 === void 0 ? void 0 : _this$calendarConfig$4.view.activeEnd) !== null && _this$calendarConfig$3 !== void 0 ? _this$calendarConfig$3 : (0, _time.days)(7, new Date())
      };
    }

    get selectedSocialProfileIds() {
      var _this$auth$currentSoc;

      return (0, _utils.isEmpty)(this.selectedSocialProfiles.profiles) ? [(_this$auth$currentSoc = this.auth.currentSocialProfile) === null || _this$auth$currentSoc === void 0 ? void 0 : _this$auth$currentSoc.id] : this.selectedSocialProfiles.profileIds;
    }

    get shouldShowBttpPromo() {
      var _this$singleSocialPro;

      return !this.account.isOnLegacyPlan && this.bttp.isValidSocialProfile && !this.multipleProfilesSelected && !((_this$singleSocialPro = this.singleSocialProfile) !== null && _this$singleSocialPro !== void 0 && _this$singleSocialPro.receivedBttpDiscovery);
    }

    get userTimeSlots() {
      return this.singleSocialProfile ? this.singleSocialProfile.userTimeSlots : [];
    }

    *prefetch(start) {
      // Note:  Note: #getInitialDate needed for each variable declaration as functions in shared/utils/time mutate the Date object
      const prefetchStart = (0, _time.days)(-7, _classPrivateMethodGet(this, _getInitialDate, _getInitialDate2).call(this, start));
      const prefetchEnd = (0, _time.days)(14, _classPrivateMethodGet(this, _getInitialDate, _getInitialDate2).call(this, start)); // Note: Prefetch events for the previous and next week views

      yield (0, _emberConcurrencyTs.taskFor)(this.getEvents).perform({}, {
        start: prefetchStart,
        end: prefetchEnd,
        isPrefetch: true
      });
    }

    *getEvents() {
      var _this$fullCalendar;

      let cachedData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let fetchInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultFetchInfo;
      const {
        isPrefetch,
        start,
        end
      } = fetchInfo;
      const {
        cacheNotes,
        cachePosts,
        cacheBttpTimeSlots,
        cacheTimeSlots
      } = cachedData;

      const params = _classPrivateMethodGet(this, _getParams, _getParams2).call(this, fetchInfo);

      const eventsAreFetched = _classPrivateMethodGet(this, _eventsFetched, _eventsFetched2).call(this, start, end);

      const postsAreCached = eventsAreFetched && cachePosts;
      const notesAreCached = eventsAreFetched && cacheNotes; // Note: Temporary check to get additional error info regarding: https://rollbar.com/latermedia/latergramit/items/10386/

      if (isNaN(params.start_time) || isNaN(params.end_time)) {
        this.errors.log('Invalid query params', {
          fetchInfo,
          params
        }, 'warning');
      } // Note: If events have already been fetched, use data from store intead of making a request


      const posts = postsAreCached ? cachePosts : yield _classPrivateMethodGet(this, _fetchFromStore, _fetchFromStore2).call(this, 'gram', params, eventsAreFetched);
      const notes = notesAreCached ? cacheNotes : yield _classPrivateMethodGet(this, _fetchOrIgnoreNotes, _fetchOrIgnoreNotes2).call(this, params, eventsAreFetched);
      const userTimeSlots = cacheTimeSlots || this.userTimeSlots; // Note: Add new date range to fetchedDateRanges after fetching

      if (!eventsAreFetched) {
        this.fetchedDateRanges.pushObject({
          start,
          end
        });
      } // Note: Do not return events if this is a prefetch


      if (isPrefetch) {
        return [];
      }

      const filteredPosts = _classPrivateMethodGet(this, _filterPosts, _filterPosts2).call(this, posts, fetchInfo);

      const filteredNotes = _classPrivateMethodGet(this, _filterNotes, _filterNotes2).call(this, notes);

      const bttpSlotEvents = _classPrivateMethodGet(this, _formatTimeSlotsAsEvents, _formatTimeSlotsAsEvents2).call(this, cacheBttpTimeSlots);

      const postEvents = _classPrivateMethodGet(this, _formatPostsAsEvents, _formatPostsAsEvents2).call(this, filteredPosts);

      const noteEvents = _classPrivateMethodGet(this, _formatNotesAsEvents, _formatNotesAsEvents2).call(this, filteredNotes);

      const userSlotEvents = _classPrivateMethodGet(this, _formatTimeSlotsAsEvents, _formatTimeSlotsAsEvents2).call(this, userTimeSlots); // Note: Only return post and note events for month view


      if (((_this$fullCalendar = this.fullCalendar) === null || _this$fullCalendar === void 0 ? void 0 : _this$fullCalendar.view.type) === MONTH) {
        return [postEvents, noteEvents].flat();
      } // Note: Only return bttp and bttp promo events in the event that the user's social profile is valid and multiple profiles are not selected


      if (this.multipleProfilesSelected || !this.bttp.isValidSocialProfile) {
        return [postEvents, noteEvents, userSlotEvents].flat();
      }

      const events = [postEvents, noteEvents, bttpSlotEvents, userSlotEvents].flat();

      if (this.calendarConfig.calendarView === WEEK && this.shouldShowBttpPromo && (0, _utils.isEmpty)(bttpSlotEvents)) {
        _classPrivateMethodGet(this, _addBttpPromoEvent, _addBttpPromoEvent2).call(this, events);
      }

      return events;
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "account", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentGroupId", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "multipleProfilesSelected", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "singleSocialProfile", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "prefetch", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "prefetch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getEvents", [_emberConcurrencyDecorators.restartableTask], Object.getOwnPropertyDescriptor(_class.prototype, "getEvents"), _class.prototype)), _class));
  _exports.default = EventsService;

  function _addBttpPromoEvent2(events) {
    const calendarStartTime = (0, _moment.default)(this.defaultFetchInfo.start).tz(this.calendarConfig.timeZoneIdentifier);
    const bttpPromoTimeSlot = (0, _findBestFitOpenTimeslot.default)({
      events,
      calendarStartTime,
      defaultTimedEventDuration: this.defaultTimedEventDuration
    });

    if (bttpPromoTimeSlot && bttpPromoTimeSlot.start) {
      events.push(_classPrivateMethodGet(this, _createBttpPromoTimeSlotEvent, _createBttpPromoTimeSlotEvent2).call(this, bttpPromoTimeSlot));
    }
  }

  function _createBttpPromoTimeSlotEvent2(_ref) {
    let {
      start,
      end
    } = _ref;
    return _calendarEvent.default.create({
      start,
      end,
      allDay: false,
      eventType: BTTP_PROMO,
      editable: false
    });
  }

  function _eventsFetched2(start, end) {
    if ((0, _utils.isEmpty)(this.fetchedDateRanges)) {
      return false;
    }

    return this.fetchedDateRanges.any(dateRange => _classPrivateMethodGet(this, _isWithinDates, _isWithinDates2).call(this, start, end, dateRange));
  }

  function _fetchFromStore2(model, params, prefetchComplete) {
    if (prefetchComplete) {
      return this.store.peekAll(model);
    }

    return this.store.query(model, params);
  }

  function _fetchOrIgnoreNotes2(params, prefetchComplete) {
    if (this.calendarType === STORIES) {
      return [];
    }

    return _classPrivateMethodGet(this, _fetchFromStore, _fetchFromStore2).call(this, 'calendar-note', params, prefetchComplete);
  }

  function _filterNotes2(notes) {
    return notes.filter(note => note.group.get('id') === this.currentGroupId);
  }

  function _filterPosts2(posts, _ref2) {
    let {
      start,
      end
    } = _ref2;
    return posts.filter(post => {
      const socialProfile = post.get('socialProfile');
      const socialProfileId = socialProfile.get('id');
      const isWithinDates = (0, _moment.default)(post.start).isBetween(start, end);
      const showReels = post.isInstagramReel ? this.auth.currentAccount.rolloutInstagramReelsApi : true;
      return this.selectedSocialProfileIds.includes(socialProfileId) && isWithinDates && !post.isDeleted && !post.isInstagramStory && !post.isNew && post.active && post.startTime && showReels;
    });
  }

  function _formatPostsAsEvents2(posts) {
    return posts.reduce((result, post) => {
      const {
        id,
        start,
        calendarOrProcessingUrl,
        isCarouselPost,
        isInstagramReel,
        hasErrorIcon,
        unverified,
        isEditable,
        autoPublish,
        locked
      } = post.getProperties('id', 'start', 'calendarOrProcessingUrl', 'isCarouselPost', 'isInstagramReel', 'hasErrorIcon', 'unverified', 'isEditable', 'autoPublish', 'locked');
      const socialProfile = post.get('socialProfile');
      const eventObject = {
        id,
        autoPublish,
        calendarOrProcessingUrl,
        displayEventTime: true,
        durationEditable: false,
        editable: isEditable,
        eventType: POST,
        hasError: hasErrorIcon,
        isCarouselPost,
        locked,
        post,
        start,
        unverified,
        socialProfileId: socialProfile.get('id'),
        profileIconClass: socialProfile.get('profileIconClass'),
        avatarChildClass: socialProfile.get('avatarChildClass'),
        profileColorClass: (0, _profileColorOutlineClass.profileColorOutlineClass)([socialProfile.get('profileColorClass')])
      };
      const finalizedEventObject = this.auth.currentAccount.rolloutInstagramReelsApi ? Object.assign(eventObject, {
        isInstagramReel
      }) : eventObject;
      result.push(_calendarEvent.default.create(finalizedEventObject));
      return result;
    }, []);
  }

  function _formatNotesAsEvents2(notes) {
    return notes.map(note => {
      var _this$userConfig$curr;

      if (!note || !note.moment) {
        return {};
      }

      const time = note.moment.tz((_this$userConfig$curr = this.userConfig.currentTimeZone) === null || _this$userConfig$curr === void 0 ? void 0 : _this$userConfig$curr.identifier);
      const endTime = (0, _moment.default)(time).add(30, 'minutes');
      const obj = {
        allDay: false,
        backgroundColor: 'white',
        displayNote: note.displayNote,
        end: endTime.format(),
        eventType: NOTE,
        id: note.id,
        note,
        noteContent: note.noteContent,
        noteSummary: note.summary,
        start: time.format(),
        startDay: time.weekday()
      };
      return _calendarEvent.default.create(obj);
    });
  }

  function _formatTimeSlotsAsEvents2() {
    let timeSlots = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const formattedTimeSlots = [];
    timeSlots.forEach(timeSlot => {
      const start = (0, _moment.default)().clone().utc();
      const {
        wday,
        hour,
        minute,
        isBttp,
        isUser
      } = timeSlot;
      Number.isInteger(wday) && start.day(wday);
      Number.isInteger(hour) && start.hour(hour);
      Number.isInteger(minute) && start.minute(minute);
      start.tz(this.calendarConfig.timeZoneIdentifier);
      const baseEvent = {
        allDay: false,
        daysOfWeek: [start.day()],
        durationEditable: false,
        id: timeSlot.id,
        isBttp,
        isUser,
        profileColorClass: timeSlot.get('socialProfile.profileColorClass'),
        startTime: start.format('HH:mm'),
        stick: true
      };
      const bttpEvent = {
        display: 'background',
        eventType: BTTP
      };
      const userEvent = {
        backgroundColor: '#ddd',
        editable: Boolean(timeSlot.id),
        eventType: TIME_SLOT
      };

      if (!timeSlot.isDeleted) {
        const eventAttributes = isBttp ? bttpEvent : userEvent;
        const event = Object.assign(baseEvent, eventAttributes);
        formattedTimeSlots.push(_calendarEvent.default.create(event));
      }
    });
    return formattedTimeSlots;
  }

  function _getInitialDate2(start) {
    return new Date(start.getTime());
  }

  function _getParams2(_ref3) {
    let {
      start,
      end,
      isPrefetch
    } = _ref3;

    const startDate = _classPrivateMethodGet(this, _queryDate, _queryDate2).call(this, start, isPrefetch, -7);

    const endDate = _classPrivateMethodGet(this, _queryDate, _queryDate2).call(this, end, isPrefetch, 7);

    return {
      query_type: 'time',
      start_time: startDate.getTime() / 1000,
      end_time: endDate.getTime() / 1000,
      group_id: this.currentGroupId
    };
  }

  function _isWithinDates2(start, end, dateRange) {
    const currentStart = (0, _moment.default)(start);
    const currentEnd = (0, _moment.default)(end);
    const startDateWithinRange = currentStart.isSameOrAfter(dateRange.start) || currentStart.isBetween(dateRange.start, dateRange.end);
    const endDateWithinRange = currentEnd.isSameOrBefore(dateRange.end) || currentEnd.isBetween(dateRange.start, dateRange.end);
    return startDateWithinRange && endDateWithinRange;
  }

  function _queryDate2(date, isPrefetch, offset) {
    const queryDate = new Date(date.getTime());

    if (!isPrefetch) {
      queryDate.setDate(queryDate.getDate() + offset);
    }

    return queryDate;
  }
});